import type { components } from "#/schema";

// Type-safe array of beweegactiviteit field names that must exist in the schema
export const beweegactiviteitFields = [
  "beweegactiviteitEenTwee",
  "beweegactiviteitDrieVier",
  "beweegactiviteitVijfZes",
  "beweegactiviteitZevenAcht",
] as const satisfies ReadonlyArray<
  keyof Pick<
    components["schemas"]["BeweegactiviteitenreeksDetailModel"],
    | "beweegactiviteitEenTwee"
    | "beweegactiviteitDrieVier"
    | "beweegactiviteitVijfZes"
    | "beweegactiviteitZevenAcht"
  >
>;

// Type-safe array of LeerjaarCombo values excluding "None"
export const leerJaarComboWithoutNone = [
  "EenTwee",
  "DrieVier",
  "VijfZes",
  "ZevenAcht",
] as const satisfies ReadonlyArray<Exclude<components["schemas"]["LeerjaarCombo"], "None">>;

// Type derived from the const array
export type BeweegactiviteitFieldNames = (typeof beweegactiviteitFields)[number];

// When creating a new beweegactiviteitenreeks, the beweegthema should be undefined
// so the user explicitly has to choose a beweegthema
export interface CrudBeweegactiviteitenreeksDetailModel extends Omit<
  components["schemas"]["BeweegactiviteitenreeksDetailModel"],
  "beweegthema"
> {
  // Default beweegthema is undefined
  beweegthema?: components["schemas"]["Beweegthema"];
}
